import { QueryClient, UseQueryOptions, useQuery } from "@tanstack/react-query";
import { getPodBucketAttachments } from "api/services/shipment";
import { shipmentQueryKeys } from "./shipmentQueryKeys";

export type PodBucketAttachment = {
  file_id: number;
  reference_number: string;
  filename: string;
  url: string;
  size: number | null;
  attachment_id: number | null;
  bucket_name: string;
  is_mandatory: boolean;
};

type PodBucketAttachmentsQueryData = { results: PodBucketAttachment[] };

export const writePodBucketAttachmentsCache = (
  queryClient: QueryClient,
  shipmentId: string,
  updater: (results: PodBucketAttachment[]) => PodBucketAttachment[],
) => {
  queryClient.setQueryData<PodBucketAttachmentsQueryData>(
    shipmentQueryKeys.podBucketAttachments(shipmentId),
    (prev) => ({ results: updater(prev?.results ?? []) }),
  );
};

export const useGetPodBucketAttachments = (
  shipmentId: string,
  options?: UseQueryOptions<{ results: PodBucketAttachment[] }>,
) =>
  useQuery({
    queryKey: shipmentQueryKeys.podBucketAttachments(shipmentId),
    queryFn: ({ signal }) =>
      getPodBucketAttachments(shipmentId, { signal }).then((res) => res.data),
    enabled: !!shipmentId,
    ...options,
  });
